import Fetch from "./Fetch";
import { handleError, handleResponse } from "./ApiUtils";

import { API_BASIC_URL_USER_MANAGEMENT } from "../config/constants";

export const getAdditionalServicesTypes = () => {
  return Fetch.get(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/features`).then(handleResponse).catch(handleError);
};
